/**
 * Created by mariushirjanu on 23/01/2020.
 */
import * as _ from 'underscore';
import { HttpDataService, IHttpDataCache } from '../http/http-data.service';
import { ILanguage } from '@type_definitions/datatypes';
import { Injectable } from '@angular/core';

export enum Lang {
  CS = 'cs', // Czech
  DE = 'de', // German
  EL = 'el', // Greek
  EN = 'en', // English
  ES = 'es', // Spanish
  FR = 'fr', // French
  HR = 'hr', // Croatian
  HU = 'hu', // Hungarian
  IT = 'it', // Italian
  JA = 'ja', // Japanese
  KO = 'ko', // Korean
  NL = 'nl', // Dutch
  NO = 'no', // Norwegian
  PL = 'pl', // Polish
  PT = 'pt', // Portuguese
  RU = 'ru', // Russian
  SL = 'sl', // Slovenian
  TR = 'tr', // Turkish
  ZH = 'zh'  // Chinese
}

export const DEFAULT_LANGUAGE:Lang = Lang.EN;
export const ALLOWED_LANGUAGES:string[] = _.values(Lang);

@Injectable()
export class LanguageDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
  }

  public getLanguages():Promise<ILanguage[]> {
    return this.cache.doGET(
      'rest/languages',
      undefined,
      undefined,
      'Error loading languages'
    );
  }
}